/*
 * Pages through an existing list API so a CSV holds every row matching the current filters, not
 * just the page on screen. Works for offset and cursor APIs: fetch_page(cursor) resolves
 * { rows, next } where next is the following cursor/offset, or null/undefined at the end.
 */
export const CSV_ROW_CAP = 10000;

export const capped_text = (cap = CSV_ROW_CAP) =>
  `Only the first ${cap.toLocaleString('en-IN')} rows were downloaded. Narrow the filters to get the rest.`;

export const collect_all_pages = async (
  fetch_page,
  { cap = CSV_ROW_CAP, max_pages = 1000 } = {}
) => {
  let rows = [];
  let cursor = null;
  for (let i = 0; i < max_pages; i += 1) {
    // eslint-disable-next-line no-await-in-loop -- pages are sequential by nature (cursor chain)
    const page = (await fetch_page(cursor)) || {};
    rows = rows.concat(page.rows || []);
    if (rows.length > cap) return { rows: rows.slice(0, cap), capped: true, cap };
    const done = page.next === null || page.next === undefined || page.next === '';
    // An empty page that still claims a next cursor would loop forever; treat it as the end.
    if (done || !(page.rows || []).length) return { rows, capped: false, cap };
    cursor = page.next;
  }
  return { rows, capped: true, cap };
};

// Offset APIs: next offset while the server still reports more rows (by total, or a full page).
export const next_offset = ({ offset, page_size, row_count, total_count }) => {
  const reached = offset + row_count;
  if (typeof total_count === 'number') return reached < total_count ? reached : null;
  return row_count >= page_size ? reached : null;
};
